<template>
  <div class="relative w-full h-auto py-[3.75vw]">
    <el-image
      class="absolute top-0 left-0 w-full h-full"
      :src="backgroundImage"
      lazy
      fit="cover"
      style="object-position: center"
    ></el-image>
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[2.5vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-[3.3vw] flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#FFFFFF] font-harmony font-bold leading-[3.25vw] text-center"
        >
          为什么选择蓝悦
        </div>
      </div>
      <!-- 副标题框 -->
      <div class="h-[3vw] flex flex-col justify-center items-center">
        <div
          class="text-[1.25vw] text-[#FFFFFFA6] font-harmony font-normal leading-[2.97vw] text-center"
        >
          青少年航空科技创新教育践行者
        </div>
      </div>
    </div>

    <!-- 内容框 -->
    <div class="relative mx-auto w-[61.46vw] grid grid-cols-2 gap-[1.04vw]">
      <div
        v-for="(item, index) in contentItems"
        :key="item.id"
        class="w-[30.1vw] h-[9.79vw] px-[1.56vw] py-[1.77vw] bg-white/10 rounded-xl shadow-[0px_12px_63px_0px_rgba(0,0,0,0.09)] flex items-start gap-[1.04vw] transition-all duration-500 ease-[cubic-bezier(0.25,0.1,0.25,1.5)] hover:scale-105 hover:bg-white/20 hover:shadow-[0px_16px_70px_0px_rgba(0,0,0,0.25)] transform-gpu origin-center will-change-transform cursor-default"
        :style="`transition-delay: ${index * 50}ms`"
      >
        <!-- 图标容器 -->
        <div
          class="relative w-[2.6vw] h-[2.6vw] transition-transform duration-500 hover:rotate-12"
        >
          <img
            :src="require(`@/assets/images/Home/module3/${item.icon}`)"
            class="w-full h-full object-contain transition-all duration-700 hover:scale-110"
            :alt="`icon-${index+1}`"
          />
        </div>

        <!-- 文字内容 -->
        <div class="flex-1 will-change-auto">
          <div
            class="text-[1.25vw] text-white font-harmony font-bold leading-normal mb-[0.52vw] will-change-auto"
          >
            {{ item.title }}
          </div>
          <p
            class="text-[0.833vw] text-white font-alibaba font-normal leading-[171.5%] will-change-auto"
          >
            {{ item.description }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home-module3",
  data() {
    return {
      backgroundImage: require("@/assets/images/Home/module3/sample1.png"),
      contentItems: [
        {
            id:1,
            title: "高校合作",
            description:
            "整合无人机科技前沿，与西北工业大学、陕西师范大学等学府合作，融合基础教学经验，为学生提供高质量的教育服务。",
            icon: 'icon7.png'
        },
        {
            id:2,
          title: "赛事成果",
          description:
            "上百所学校科普宣传，受益学生十余万，辅导学生在“飞向北京-飞向太空”比赛和“全国无人机大赛”等众多教育部白名单赛事中获奖无数。",
            icon: 'icon2.png'

        },
        {
            id:3,
          title: "考试服务",
          description:
            "提供“小小飞行员”等级认证、“青少年航空科技教育小创客证书”考试服务。",
            icon: 'icon3.png'

        },
        {
            id:4,
          title: "名师团队",
          description: "航空航天领域专家 + 一线教育名师联合授课。",
            icon: 'icon4.png'

        },
        {
            id:5,
          title: "课程体系",
          description:
            "覆盖小学至高中全学段，分龄教学目标清晰（如小学兴趣引导、初中协同合作、高中自主创新）。",
            icon: 'icon5.png'

        },
        {
            id:6,
          title: "赛事出口",
          description:
            "直通全国无人机大赛，为学生提供总结收获平台，锻炼学生自信与能力，助力升学与背景提升。",
            icon: 'icon6.png'

        },
      ],
    };
  },
};
</script>

<style scoped>
</style>
